module.exports = __webpack_public_path__ + "static/img/paymentlogo.bf22844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paymentlogo.png
// module id = GVdN
// module chunks = 128